// Counter section

document.addEventListener("DOMContentLoaded", function () {

  const counters = document.querySelectorAll(".counter-number");

  const animateCounter = (el) => {
    const target = parseFloat(el.getAttribute("data-target"));
    const suffix = el.getAttribute("data-suffix") || '';

    let count = 0;
    const speed = 200;

    const isDecimal = target % 1 !== 0 || suffix.includes('.');

    const update = () => {
      const increment = target / speed;

      if (count < target) {
        count += increment;

        if (isDecimal) {
          el.textContent = count.toFixed(1) + suffix.replace('.0','');
        } else {
          el.textContent = Math.floor(count) + suffix;
        }

        requestAnimationFrame(update);
      } else {
        if (isDecimal) {
          el.textContent = target.toFixed(1) + suffix.replace('.0','');
        } else {
          el.textContent = target + suffix;
        }
      }
    };

    update();
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(counter => observer.observe(counter));

});

// free-shipping-progress

document.addEventListener("cart:updated", updateFreeShippingBar);
document.addEventListener("DOMContentLoaded", updateFreeShippingBar);

function updateFreeShippingBar() {

  const wrapper = document.querySelector('.free-shipping-bar-wrapper');
  if (!wrapper) return;

  let threshold = parseFloat(wrapper.dataset.threshold) * 100;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      let total = cart.total_price;

      let progress = document.querySelector('.free-shipping-progress');
      let text = document.querySelector('.free-shipping-text');

      if (!progress || !text) return;

      let percent = Math.min((total / threshold) * 100, 100);
      progress.style.width = percent + "%";

      if (total < threshold) {

        let remaining = threshold - total;

        text.classList.remove("success");
        text.innerHTML = `You’re 
          <span class="highlight">
            ${Shopify.formatMoney(remaining)}
          </span> 
          away from <span class="green">Free shipping</span>`;

      } else {

        text.innerHTML = `🎉 Congrats! You've unlocked Free Shipping!`;
        text.classList.add("success");

      }

    });
}
// Cart drawer PDP slider

function initYouMayAlsoLike() {

  /* =========================
     SWIPER INIT 
  ========================== */

  if (window.youMaySwiper && typeof window.youMaySwiper.destroy === 'function') {
    window.youMaySwiper.destroy(true, true);
  }

  const slider = document.querySelector(".you-may-also-slider");

  if (slider) {
    window.youMaySwiper = new Swiper(".you-may-also-slider", {
      slidesPerView: 1,
      spaceBetween: 12,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  }


  /* =========================
     HIDE PRODUCTS IN CART
  ========================== */

  function hideProductsInCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        const cartVariantIds = cart.items.map(item => item.variant_id);

        document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
          const variantId = parseInt(btn.dataset.variantId);

          if (cartVariantIds.includes(variantId)) {
            const slide = btn.closest('.swiper-slide');
            if (slide) slide.remove();
          }
        });

        const remainingSlides = document.querySelectorAll('.you-may-also-slider .swiper-slide');

        if (remainingSlides.length === 0) {
          const section = document.querySelector('.you-may-also-like');
          if (section) section.style.display = 'none';
        }

        if (window.youMaySwiper) {
          window.youMaySwiper.update();
        }

      });
  }


  /* =========================
     ADD TO CART + LOADER
  ========================== */

  document.querySelectorAll(".add-to-cart-btn").forEach(btn => {

    if (btn.classList.contains("event-added")) return;
    btn.classList.add("event-added");

    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const variantId = this.dataset.variantId;

      const spinner = this.querySelector('.loading__spinner');
      const icon = this.querySelector('svg');

      
      this.classList.add('loading');
      this.disabled = true;

      if (spinner) spinner.classList.remove('hidden');
      

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      })
      .then(res => res.json())
      .then(() => {

       
        fetch('/?sections=cart-drawer')
          .then(res => res.json())
          .then(data => {

            const parser = new DOMParser();
            const html = parser.parseFromString(data['cart-drawer'], 'text/html');

            const newDrawer = html.querySelector('#CartDrawer');
            const currentDrawer = document.querySelector('#CartDrawer');

            if (newDrawer && currentDrawer) {
              currentDrawer.innerHTML = newDrawer.innerHTML;
            }

              

            setTimeout(() => {
              initYouMayAlsoLike();
            }, 200);

          });

      })
      .catch(() => {
        console.log("Error adding product");
      })
      .finally(() => {

        // ✅ STOP LOADING
        this.classList.remove('loading');
        this.disabled = false;

        if (spinner) spinner.classList.add('hidden');
        if (icon) icon.style.display = '';

      });

    });

  });

  hideProductsInCart();
}


/* =========================
   INITIAL LOAD
========================== */

document.addEventListener("DOMContentLoaded", function () {
  initYouMayAlsoLike();
});


/* =========================
   FETCH INTERCEPT
========================== */

(function () {
  const originalFetch = window.fetch;

  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(async (response) => {

      if (
        response.url.includes('/cart/add') ||
        response.url.includes('/cart/change') ||
        response.url.includes('/cart/update')
      ) {
        setTimeout(() => {
          initYouMayAlsoLike();
        }, 300);
      }

      return response;
    });
  };
})();



// Page redirect

document.querySelectorAll('input[name="inquiry_type"]').forEach((input) => {
  input.addEventListener("change", function () {
    const redirectUrl = this.dataset.redirect;

    if (redirectUrl) {
      window.location.href = redirectUrl;
      return;
    }

    document.getElementById("selected-inquiry").value = this.value;
  });
});
// 
document.addEventListener("DOMContentLoaded", function () {

  const tabLinks = document.querySelectorAll(".tab-link");
  const tabContents = document.querySelectorAll(".tab-content");

  tabLinks.forEach(link => {
    link.addEventListener("mouseenter", function (e) {
      e.preventDefault();

      const tabId = this.dataset.tab;

      // remove active
      tabLinks.forEach(l => l.classList.remove("active"));
      tabContents.forEach(c => c.classList.remove("active"));

      // add active
      this.classList.add("active");
      document.getElementById(tabId).classList.add("active");
    });
  });

});

// 

function updateAllCardHeights() {
  const cards = document.querySelectorAll('.card__inner .card__media .media');

  if (!cards.length) return;

  cards.forEach(card => {
    const height = card.offsetHeight;
   document.documentElement.style.setProperty('--card-height', height + 'px');
  });
}

// Run initially
updateAllCardHeights();

// Watch for dynamically loaded sections (like related products)
const observer = new MutationObserver(() => {
  updateAllCardHeights();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});